import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import HeaderBottom from "../../components/HomePage/HeaderBottom";


const BlogPostDetails = () => {
    const { titleSlug } = useParams(); // Extract the blog post titleSlug from the URL
    const [blogPost, setBlogPost] = useState(null); // State to store the blog post details
    const [author, setAuthor] = useState([]);



    const { categorySlug } = useParams();

    // Fetch author details
    useEffect(() => {
        fetch("https://marchtwo202501-5801b8caeb3a.herokuapp.com/author")
            .then((res) => res.json())
            .then((info) => setAuthor(info))
            .catch((error) => console.error("Error fetching author details:", error));
    }, []);

    // Fetch blog post details by titleSlug
    useEffect(() => {
        if (titleSlug) {
            fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/blog/${titleSlug}`)
                .then((res) => res.json())
                .then((info) => {
                    console.log("Blog post data:", info); // Log to check the response
                    setBlogPost(info);
                })
                .catch((error) => console.error("Error fetching blog post:", error));
        }
    }, [titleSlug]);

    useEffect(() => {
        if (categorySlug) {
            fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/blog/${categorySlug}`)
                .then((res) => res.json())
                .then((info) => {
                    console.log("Blog post data:", info); // Log to check the response
                    setBlogPost(info);
                })
                .catch((error) => console.error("Error fetching blog post:", error));
        }
    }, [categorySlug]);

    // If blogPost is null, show a loading state
    if (!blogPost) {
        return (
            <>
                <HeaderBottom />
                <div className="blog-section vh-100 flex items-center justify-center">
                    <p>Loading...</p>
                </div>
            </>
        );
    }

    return (
        <>
            {/* Dynamic Helmet for SEO */}
            <Helmet>
                <title>{blogPost.authorName} </title>
                <meta name="description" content={blogPost.description.slice(0, 160)} />
                <meta name="keywords" content={`Blog, ${blogPost.postCategoryName}, ${blogPost.authorName}`} />
                <meta property="og:title" content={blogPost.postTitle} />
                <meta property="og:description" content={blogPost.description.slice(0, 160)} />
                <meta property="og:image" content={blogPost.featuredImage} />
                <meta property="og:type" content="article" />
                <meta property="og:url" content={`https://marchtwo202501-5801b8caeb3a.herokuapp.com/blog/${titleSlug}`} />
            </Helmet>



            <div className="d-flex justify-content-center py-5 mt-5">
                <div className="container-lg">
                    {/* Breadcrumb Navigation */}
                    {/* Breadcrumb Navigation */}
                    <nav className="mb-4 col-lg-8 mx-auto position-relative" style={{ height: '100px', backgroundImage: `url(${blogPost.postImageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        <div className="overlay d-flex justify-content-center align-items-center" style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#F0F7FC', borderRadius: '' }}>
                            <h1 className="breadcrumb  two-head ">
                                <li className="breadcrumb-item">
                                    <Link to="/" className=" text-decoration-none">
                                        <i className="fas fa-home"></i> Home
                                    </Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="/blog" className=" text-decoration-none">
                                        Blog
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active " aria-current="page">
                                    {blogPost.postTitle}
                                </li>
                            </h1>
                        </div>
                    </nav>




                    {/* Blog Content */}
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="bg-white p-4 rounded shadow-sm">




                                {/* Blog Title */}
                                <h1 className="mt-4 mb-5 one-head">{blogPost.postTitle}</h1>

                                {/* Meta Info */}
                                <ul className="list-unstyled d-flex flex-wrap gap-4">
                                    {author.map((c) => (
                                        <li key={c._id} className="fw-semibold fs-4 text-dark one-head d-flex align-items-center mb-2">
                                            <i className="fas fa-user-circle me-2 fa-lg text-primary"></i> By {c.allAuthorName}
                                        </li>
                                    ))}
                                    <li className="fw-semibold fs-4 text-dark d-flex align-items-center mb-2">
                                        <i className="fas fa-calendar-alt me-2 fa-lg text-danger"></i> {blogPost.postDate}
                                    </li>
                                    {/* <li className="fw-semibold fs-4 text-dark d-flex align-items-center mb-2">
                                        <i className="fas fa-tag me-2 fa-lg text-success"></i>
                                        <Link to={`/category/${blogPost.postCategoryName}`} className="text-primary text-decoration-none">
                                            {blogPost.postCategoryName}
                                        </Link>
                                    </li> */}
                                </ul>


                                {/* Featured Image */}
                                <div className="mb-5 mt-5">
                                    <img
                                        src={blogPost.featuredImage}
                                        alt={blogPost.postTitle}
                                        className="w-100  rounded shadow-lg"
                                        style={{ height: "50vh", objectPosition: "" }}
                                    />
                                </div>


                                {/* Blog Description */}
                                <div
                                    className="mt-4  fs-3 paragraph" // fs-3 makes the text larger
                                    dangerouslySetInnerHTML={{ __html: blogPost.description }}
                                >
                                </div>

                            </div>
                        </div>

                        {/* Author Section */}
                        {author.length > 0 && (
                            <div className="col-lg-8 mt-5">
                                {author.map((a) => (
                                    <div className="mt-4 bg-white p-4 rounded shadow-sm" key={a.id}>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src={a.AuthorImage}
                                                alt="Author Image"
                                                className="rounded-circle me-3"
                                                style={{ width: 80, height: 80 }}
                                            />
                                            <div>
                                                <h1 className="mb-1">{a.allAuthorName}</h1>
                                                <p className="text-muted mb-2">{a.AuthorTitle}</p>
                                                <p className="mb-0 text-justify fs-3 paragraph">
                                                    {a.authorDetails}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

        </>
    );
};

export default BlogPostDetails;